export default {
    clients: 'клиенты',
    search_clients: 'Поиск',
    choosen_client: 'Выбранный клиент',
    add_client: 'Ссылка для приглашения',
    add_new_client: 'Добавить клиента',
    invitation_link: 'Invitation link',
    info: '*Перед созданием клиента проверьте введенные данные. Если вы введете email, клиент получит приглашение для завершения регистрации по email (рекомендуется). Если email отсутствует, приглашение будет отправлено по SMS, т.к. номер телефона обязателен. Клиент в дальнейшем может изменить свои данные, вы же вводите только начальные данные. Если email уже есть в нашей системе, данные будут заполнены автоматически.**Before creating a client, check the entered data. If you enter an email, the client will receive an invitation to complete the registration via email (recommended). If there is no e-mail, the invitation will be sent by SMS because the phone number is mandatory. The client can later change his data, while you enter only the initial data. If the email already exists in our system, the data will be filled in automatically.*',
    number_of_clients:
        'В настоящее время у вашей компании <b>{number} клиентов</b> на платформе <b>bookeraj</b> — месте, где все ваши важные контакты всегда под рукой. 🚀',
    first_and_last_name: 'Имя и фамилия',
    email: 'Электронная почта',
    phone_number: 'Номер телефона',
    active: 'Активный',
    records: 'Примечания',
    history: 'История',
    client_reservations: 'Бронирование от клиента: {client}',
    no_client_found: 'Клиент не выбран!',
    client_not_selected:
        'Клиент не выбран, поэтому его запись не будет сохранена. Вы хотите продолжить и подтвердить бронирование?',
}
